import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DipRegistrationService} from '../dip-registration.service';
import {DipRegistrationConfirmService} from '../core/services/dip-registration-confirm.service';
import {DipRegistrationContextService} from '../core/services/dip-registration-context.service';
import {DipRegistrationAlertStore} from '../core/services/alert/dip-registration-alert-store.service';
import {DipRegistrationNavigationService} from '../core/services/dip-registration-navigation.service';
import {DipRegistrationInitializerService} from '../core/services/dip-registration-initializer.service';
import {DipRegistrationLoggerService} from '../core/services/logger/dip-registration-logger.service';
import { DiprsSpaLoggerService } from '../core/services/logger/diprs-spa-logger.service';
import { DipRegistrationLoggingNames } from '../core/enum/dip-registration-logging-names.enum';
import { LoggerEventEnum } from '../core/models/dip-registration-log-information.model';
import { IdleService } from '../shared/services/idle.service';
import { DipRegistrationCustomerIdentityService } from '../core/services/dip-registration-customer-identity.service';

@Component({
    selector: 'dip-registration-overview',
    templateUrl: './dip-registration-overview.component.html',
    styleUrls: ['./dip-registration-overview.component.scss'],
    standalone: false
})
export class DipRegistrationOverviewComponent implements OnInit, OnDestroy {
  constructor(
    private readonly router: Router,
    private dipRegistrationAlertStore: DipRegistrationAlertStore,
    private dipRegistrationService: DipRegistrationService,
    private dipRegistrationIdleService: IdleService,
    private dipRegistrationConfirmService: DipRegistrationConfirmService,
    private dipRegistrationNavigationService: DipRegistrationNavigationService,
    private dipRegistrationContextService: DipRegistrationContextService,
    private logger: DipRegistrationLoggerService,
    private dipRegistrationInitializerService: DipRegistrationInitializerService,
    private spaLoggerService: DiprsSpaLoggerService,
    private dipRegistrationCustomerIdentityService: DipRegistrationCustomerIdentityService,
  ) {
  }

  ngOnInit() {
    this.spaLoggerService.info(LoggerEventEnum.PAGE_ENTERED, DipRegistrationLoggingNames.OVERVIEW, { previousPageId: this.dipRegistrationNavigationService.getPreviousUrl() });
    this.dipRegistrationService.startKeepingSessionAlive();
    this.dipRegistrationIdleService.start(this.dipRegistrationContextService.getSessionTimeout() + 5000);
    this.dipRegistrationConfirmService.stop();
  }

  async goToCustomerIdentify() {
    this.spaLoggerService.info(LoggerEventEnum.USER_ACTION, DipRegistrationLoggingNames.OVERVIEW, { id: 'CREATE_NEW_LOGIN' });
    this.dipRegistrationAlertStore.resetAlertState();
    this.buildSessionIfExpired(true);
    const dipssGuid = this.dipRegistrationContextService.getAppContext().dipssGuid;
    if (dipssGuid) {
      this.dipRegistrationCustomerIdentityService.create({dipssGuid});
    } else {
      await this.router.navigate(['customer-identification'], this.dipRegistrationContextService.buildParams());
    }
  }

  async getCallUAPURL() {
    this.spaLoggerService.info(LoggerEventEnum.USER_ACTION, DipRegistrationLoggingNames.OVERVIEW, { id: 'USER_EXISTING_LOGIN' });
    this.buildSessionIfExpired(false);
    this.spaLoggerService.info(LoggerEventEnum.FORWARD, DipRegistrationLoggingNames.OVERVIEW, { forwardUrl: this.dipRegistrationContextService.getUapUrl()});
    await this.dipRegistrationService.redirectToUAP();
  }

  async buildSessionIfExpired(reloadIfExpired: boolean) {
    this.logger.debug('During to inactivity in Overview page, session is expired , so we get a new session before doing any action');
    const isSessionExpired = this.dipRegistrationNavigationService.getSessionExpiredFlag();
    if (isSessionExpired) {
      this.spaLoggerService.info(LoggerEventEnum.SESSION_EXPIRED, DipRegistrationLoggingNames.OVERVIEW, null);
      if (reloadIfExpired) {
        await this.dipRegistrationService.resetAndReload('/customer-identification');
      } else {
        await this.dipRegistrationService.resetContext();
        await this.dipRegistrationInitializerService.init();
      }
    }
  }

  ngOnDestroy() {
    this.spaLoggerService.info(LoggerEventEnum.PAGE_EXITED, DipRegistrationLoggingNames.OVERVIEW, null);
    this.dipRegistrationService.stopKeepingSessionAlive();
  }
}
